export default "__VITE_ASSET__pxLEKDlv__"